import getSelectedTableView from '../utils/getSelectedTableView';
import { owaComputedFn } from 'owa-computed-fn';

const getComputedSelectedRowKeysSize: () => number = owaComputedFn(
    function getComputedSelectedRowKeysSize(): number {
        return getSelectedTableView()?.selectedRowKeys.size ?? 0;
    }
);
export default getComputedSelectedRowKeysSize;
